<template>
  <div class="div-bg">
    <img class="header-img" src="@/assets/images/module-header-img.png" />
  </div>
</template>

<script>
export default {
  name: "ModuleHeader"
};
</script>

<style lang="stylus" scoped>
.div-bg {
  position: relative;
  // margin-top: -10rem;
  width: 100%;
  // left: 5%;
  // margin-bottom: 5rem;

  .header-img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/module/components/ModuleHeader.vue